
export default {
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  methods: {
    getRelativeUrl (image) {
      if (!image?.data?.attributes?.url) {
        return ''
      }
      const { url } = image.data.attributes

      return url.replace(/^.*\/\/[^/]+/, '')
    }
  }
}
